import type { Header } from "@tanstack/react-table";

import { icons as baseIcons } from "../common";

interface SortIconProps<TData> {
  className?: string;
  header: Header<TData, unknown>;
}

const { ChevronUpIcon, ChevronDownIcon, ChevronUpDownIcon } = baseIcons.outline;

export const SortIcon = <TData,>({
  className,
  header,
}: SortIconProps<TData>) => {
  const sortDirection = header.column.getIsSorted();
  if (sortDirection === "asc") return <ChevronUpIcon className={className} />;
  if (sortDirection === "desc")
    return <ChevronDownIcon className={className} />;
  return <ChevronUpDownIcon className={className} />;
};
